import * as React from "react";
import { NavLink } from "react-router-dom";
import { LoadingViewState, RouterView } from "../RouterView";
import { formatDate } from "../../util/date";
import { RouteComponentProps, StaticContext, withRouter } from "react-router";
import { WalletService } from "../../services/WalletService";
import { getContainer } from "../../ioc/IOCSetup";
import { Account, Credit, CreditStatus } from "../../http/protocol";
import { CreditActions } from "./CreditActions";
import { UserLinkPanel } from "../user/UserLinkPanel";
import { CreditService } from "../../services/CreditService";
import { CreditEntriesList } from "./CreditEntriesList";


interface State extends LoadingViewState {
    credit?: Credit;
    account?: Account;
}


export class CreditView extends RouterView<RouteComponentProps, State>{

    creditService: CreditService;
    walletService: WalletService;
    constructor(props: RouteComponentProps) {
        super(props);
        this.creditService = getContainer().getCreditService();
        this.walletService = getContainer().getWalletService();
        this.state = { credit: {}, account: {} };
    }

    getTitle() {
        let id = (this.props.match.params as any).id;
        if (id !== "new") {
            return "Credit";
        }
        return "";
    }

    loadContent() {
        let id = (this.props.match.params as any).id;
        if (id !== "new") {
            return this.creditService.getEntity(id)
                .then((credit: Credit) => {
                    this.setState({ credit: credit });
                    this.walletService.getAccount(credit.accountId + "").then((account: Account) => {
                        this.setState({ account: account });
                    })
                })
        } else {
        }
    }

    componentDidUpdate(prevProps: RouteComponentProps<{}, StaticContext, unknown>, prevState: State): void {
        let id = (this.props.match.params as any).id;
        let prevId = (prevProps.match.params as any).id;
        if (id !== prevId) {
            this.loadContent();
        }
    }

    getDateTime(timestamp?: Date | number) {
        if (typeof (timestamp) == "undefined" || timestamp < 2) {
            return "";
        }
        return formatDate(timestamp);
    }

    getRequest(request?: String | undefined) {
        return request;
    }

    getCreditStatusBadge() {

        if (this.state.credit && this.state.credit.status === CreditStatus.PENDING) {
            return (<span className="badge badge-success warning float-right">PENDING</span>);
        } else if (this.state.credit && this.state.credit.status === CreditStatus.CANCELED) {
            return (<span className="badge badge-danger error float-right">CANCELED</span>);
        } else if (this.state.credit && this.state.credit.status === CreditStatus.PENDING)
            return (<span className="badge badge-danger success float-right">CANCELED</span>);
    }

    renderContent() {
        if (!this.state.credit || !this.state.account) {
            return <div></div>;
        }

        let accountString = "Acct " + this.state.account.id + " - Cur " + this.state.account.currencyCode + " - Type " + this.state.account.type;
        return (
            <div>
                {(this.props.match.params as any).id !== "new" && (
                    <><div className="row">
                        <div className="col-lg-6">
                            <CreditComponent credit={this.state.credit} account={this.state.account} />
                            {this.state.credit && (
                                <CreditActions onCreditUpdated={() => this.refreshContent()} credit={this.state.credit} />
                            )}
                        </div>

                        <div className="col-lg-6">
                            <div className="row">
                                <div className="col-lg-6">
                                    {this.state.credit.userId &&
                                        <UserLinkPanel userId={this.state.credit.userId} header="Credit Owner" />}
                                </div>
                            </div>
                        </div>
                    </div>
                        <div className="row">
                            <div className="col-md-12">
                                <CreditEntriesList creditId={(this.props.match.params as any).id} service={this.walletService} />
                            </div>
                        </div>
                    </>
                )}


            </div>
        );
    }
}
export default withRouter(CreditView);

export class CreditComponent extends React.Component<{ credit?: Credit, account?: Account }, {}> {

    getCreditStatusBadge(credit: Credit) {

        if (credit && credit.status === CreditStatus.PENDING) {
            return (<span className="badge badge-success warning float-right">PENDING</span>);
        } else if (credit && credit.status === CreditStatus.CANCELED) {
            return (<span className="badge badge-danger error float-right">CANCELED</span>);
        } else if (credit && credit.status === CreditStatus.PENDING)
            return (<span className="badge badge-danger success float-right">CANCELED</span>);
    }

    getDateTime(timestamp?: Date | number) {
        if (typeof (timestamp) == "undefined" || timestamp < 2) {
            return "";
        }
        return formatDate(timestamp);
    }

    render() {
        const credit = this.props.credit;
        const account = this.props.account;
        const accountString = "Acct " + credit.accountId + (account ? " - Cur " + account.currencyCode + " - Type " + account.type : "");

        return (
            <div className="card-box">
                <div className="ibox-content">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="m-b-md">
                                <dd className="pull-right">{this.getCreditStatusBadge(credit)}</dd>
                                <h4>Credit Details</h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <table className="table table-striped">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "30%" }}>Credit ID:</td>
                                        <td>{credit.id}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "30%" }}>Account ID:</td>
                                        <td>
                                            <NavLink to={"/account/" + credit.accountId}>
                                                {accountString}
                                            </NavLink>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Status:</td>
                                        <td>{credit.status}</td>
                                    </tr>
                                    <tr>
                                        <td>Provider:</td>
                                        <td>{credit.provider}</td>
                                    </tr>
                                    <tr>
                                        <td>Reference:</td>
                                        <td>{credit.reference}</td>
                                    </tr>
                                    <tr>
                                        <td>External ID:</td>
                                        <td>{credit.externalId}</td>
                                    </tr>
                                    <tr>
                                        <td>Amount:</td>
                                        <td>{credit.originalAmount}</td>
                                    </tr>
                                    <tr>
                                        <td>Owed Damount:</td>
                                        <td>{credit.owedAmount}</td>
                                    </tr>
                                    <tr>
                                        <td>Exchange Currency:</td>
                                        <td>{credit.exchangeCurrency}</td>
                                    </tr>
                                    <tr>
                                        <td>Created:</td>
                                        <td>{this.getDateTime(credit.created)}</td>
                                    </tr>
                                    <tr>
                                        <td>Updated:</td>
                                        <td>{this.getDateTime(credit.updated)}</td>
                                    </tr>
                                    <tr>
                                        <td className="col-md-4"><strong>Request:</strong></td>
                                        <td className="col-md-8">
                                            <pre style={{'overflow-wrap': 'anywhere','white-space': 'normal'}}>{credit.request}</pre>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}
